import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'

const DatePickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  return (
    <DatePicker
      {...field}
      {...props}
      showMonthYearPicker
      showFullMonthYearPicker
      showTwoColumnMonthYearPicker
      // selected={(field.value && new Date(field.value)) || null}
      onChange={val => {
        setFieldValue(field.name, moment(val).format('MM/YYYY'));
      }}
    />
  );
};


export default DatePickerField